document.addEventListener("DOMContentLoaded", function () {
  const passwordInput = document.querySelector(".show_password_input");
  const toggleButton = document.querySelector(".show_password");

  if(passwordInput && toggleButton)
  {
    toggleButton.addEventListener("click", function () {
        const isPassword = passwordInput.getAttribute("type") === "password";
        passwordInput.setAttribute("type", isPassword ? "text" : "password");
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  
  /***
  Back to top
  **/
  var backToTopButton = document.getElementById('backToTop');
  if(backToTopButton)
  {
    window.addEventListener('scroll', function () {
        if (window.scrollY > 300) {
        backToTopButton.style.display = 'block';
        } else {
        backToTopButton.style.display = 'none';
        }
    });

    backToTopButton.addEventListener('click', function () {
        window.scrollTo({
        top: 0,
        behavior: 'smooth'
        });
    });
    }
  /***
  end Back to top
  **/

});